// extracted by mini-css-extract-plugin
export default {"confirmationContent":"IssueDeletionConfirmationDialog-module__confirmationContent--dImC0"};